export enum EBrandId {
  ADMIN = '-1',
  FLEXI = '8',
  CDFPAY = '88',
  INLOOPRESI = '32',
}
